import { useNavigate } from "react-router-dom";

import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import Dialog from "components/dialog";

interface ForgotPasswordConfirmationProps {
  open: boolean;
  onClose: () => void;
}

export default function ForgotPasswordConfirmation({
  open,
  onClose
}: ForgotPasswordConfirmationProps) {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <Box sx={{ fontSize: 80 }}>
          <MarkEmailReadIcon
            sx={{ color: theme.palette.sideMenu.main }}
            fontSize="inherit"
          />
        </Box>
        <Typography
          sx={{ mt: 2 }}
          variant="h3"
          fontWeight="fontWeightBold"
          component="div"
        >
          Email Sent!
        </Typography>
        <Typography sx={{ mt: 5, lineHeight: "30px" }} variant="body2">
          If the email you entered is associated with a Suno account, you should
          receive a link to create a new password shortly.
        </Typography>
        <Button
          sx={{
            mt: 5
          }}
          size="large"
          variant="contained"
          onClick={() => navigate("/login")}
        >
          Done
        </Button>
      </Box>
    </Dialog>
  );
}
